import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';

export const Content = styled('div')(() => ({
  width: 'min(100%, 612px)',
  paddingTop: 32,
  paddingBottom: 32,
  margin: '0 auto'
}));

export const PageContainer = styled(Box)(() => ({
  position: 'relative',
  boxShadow: '0px 4px 30px 0px rgba(218, 230, 234, 1)',
  borderRadius: '10px',
  marginBottom: '32px',
}));